import { createStore } from "vuex";
import ui from "./modules/ui";
import auth from "./modules/auth"; // your existing auth module

export default createStore({
  modules: {
    ui,
    auth,
  },
});
